/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddEtcDocumentDto } from '../../models/add-etc-document-dto';
import { DocumentDto } from '../../models/document-dto';

export interface FixDocumentControllerAddEtcDocument$Params {
  centerId: string;
      body: AddEtcDocumentDto
}

export function fixDocumentControllerAddEtcDocument(http: HttpClient, rootUrl: string, params: FixDocumentControllerAddEtcDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
  const rb = new RequestBuilder(rootUrl, fixDocumentControllerAddEtcDocument.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentDto>;
    })
  );
}

fixDocumentControllerAddEtcDocument.PATH = '/api/fix-document/add-etc';
